import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import axios from "../utilis/axios";
import styles from "../styles/ForgotPassword.module.css";
// import pwcLogo from "../assets/newLogo.svg";
import pwcLogo from "assets/images/pwc.svg";
import pwcImage from "../assets/Pattern.svg";
import Input from "../components/Input";
import {
  Button,
  CircularProgress,
  Divider,
  Grid2,
  Link,
  Typography,
  InputAdornment,
  IconButton,
  FormHelperText,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  Stack,
} from "@mui/material";
import { openSnackbar, closeSnackbar } from "../store/slices/snackbar";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { HtmlTooltip } from "../contansts";
import TermsConditions from "policyterm/TermsConditions";
import PrivacyPolicy from "policyterm/PrivacyPolicy";
import ConsentNotice from "policyterm/ConsentNotice";
import { useUpdateTermsConditionsMutation } from "store/slices/apis/apiSlice";

const ForgotPassword = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:768px)');
  const { firstLogin, username } = location.state || {};
  const [email, setEmail] = useState(username || "");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [error, setError] = useState({
    resetCode: "",
    password: "",
    confirmPassword: "",
  });
  const [step, setStep] = useState(firstLogin ? 2 : 1);
  const [showResetCode, setShowResetCode] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [updateTermsFun, updateTermsRes] = useUpdateTermsConditionsMutation();

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(!open)
  }

  const handleChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const resetForm = () => {
    setResetCode("");
    setNewPassword("");
    setConfirmPassword("");
    setError({ resetCode: "", password: "", confirmPassword: "" });
  };

  useEffect(() => {
    if (firstLogin && username) {
      setStep(2);
      resetForm();
    }
  }, [firstLogin, username]);

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: { color: type },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const forgotPasswordMutation = useMutation(
    async (email) => {
      const formData = new FormData();
      formData.append("Email", email?.trim());
      const response = await axios.post("account/ForgotPassword", formData);
      return response.data;
    },
    {
      onSuccess: (data) => {
        openNotification(data.message, "success");
        setStep(2);
      },
      onError: (error) => {
        openNotification(error?.message || "Something went wrong");
      },
    }
  );

  const resetPasswordMutation = useMutation(
    async ({ email, resetCode, newPassword }) => {
      const formData = new FormData();
      formData.append("email", email?.trim());
      formData.append("otp", resetCode?.trim());
      formData.append("newPassword", newPassword?.trim());
      const response = await axios.post("account/ResetPassword", formData);
      return response.data;
    },
    {
      onSuccess: () => {
        openNotification("Password changed successfully.", "success");
        resetForm();
        navigate("/login");
      },
      onError: (error) => {
        openNotification(error?.value || "Something went wrong");
      },
    }
  );

  const handleSendResetLink = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError((prev) => ({ ...prev, email: "Email cannot be empty" }));
      return;
    }
    forgotPasswordMutation.mutate(email);
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (!isChecked && firstLogin) {
      openNotification("Please accept terms & condition");
      return
    }
    setError({ resetCode: "", password: "", confirmPassword: "" });
    let errors = {};

    if (!resetCode.trim()) {
      errors.resetCode = "Please enter reset code";
    }
    if (!newPassword.trim()) {
      errors.password = "Please enter password";
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        newPassword
      )
    ) {
      errors.password =
        "Password must be at least 8 characters long and must contain one lowercase letter, one uppercase letter, one number, and one special character.";
    }
    if (!confirmPassword.trim()) {
      errors.confirmPassword = "Please enter confirm password";
    } else if (newPassword !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }
    if (Object.keys(errors).length > 0) {
      setError((prev) => ({ ...prev, ...errors }));
      return;
    }
    resetPasswordMutation.mutate({ email, resetCode, newPassword });

    if (firstLogin) {
      const formDatas = new FormData();
      formDatas.append("email", email);
      formDatas.append("termAccepted", true);
      updateTermsFun(formDatas);
    }



  };

  const handleLogin = () => {
    navigate("/login");
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div className={styles.container}>


      <div className={styles.rightPane}>
        <div className={styles.logoContainer}>
          <img src={pwcLogo} alt="PwC Logo" style={{
            objectFit: 'inherit'
          }} />
        </div>
        <div className={styles.formContainer}>
          {/* <h2 className={styles.title}>PMIS Tool</h2> */}
          <h1 className={styles.mainTitle}>Forgot Password</h1>
          <form
            className={styles.form}
            onSubmit={step === 1 ? handleSendResetLink : handleResetPassword}
            autoComplete="off"
          >
            {step === 1 ? (
              <>
                <div className={styles.inputGroup}>
                  <Input
                    label="Enter email"
                    fullWidth
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError((prev) => ({ ...prev, email: "" }));
                    }}
                  />
                  {error.email && (
                    <FormHelperText sx={{ color: "#C52A1A", fontSize: "12px" }}>
                      {error.email}
                    </FormHelperText>
                  )}
                </div>
                <Button
                  type="submit"
                  className={styles.loginButton}
                  style={{
                    backgroundColor: theme?.customSettings?.themeColor,
                    color: "#FFF",
                  }}
                  disabled={forgotPasswordMutation.isLoading}
                >
                  {forgotPasswordMutation.isLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Send Reset Code"
                  )}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleLogin}
                  fullWidth
                  className={styles.resendBtn}
                  style={{
                    backgroundColor: "#fff",
                    color: theme?.customSettings?.themeColor,
                    borderColor: theme?.customSettings?.themeColor,
                  }}
                >
                  Back to Login
                </Button>
              </>
            ) : (
              <>
                <div className={styles.inputGroup}>
                  <Input
                    label="User Name"
                    fullWidth
                    id="email"
                    name="email"
                    value={email}
                    disabled
                  />
                </div>
                <div className={styles.inputGroup}>
                  <Input
                    fullWidth
                    name="resetCode123"
                    label="Reset Code"
                    type="text"
                    id="resetCode"
                    value={resetCode}
                    onChange={(e) => {
                      setResetCode(e.target.value);
                      setError((prev) => ({ ...prev, resetCode: "" }));
                    }}
                    autoComplete="reset-code"
                  />
                  {error.resetCode && (
                    <FormHelperText sx={{ color: "#C52A1A", fontSize: "12px" }}>
                      {error.resetCode}
                    </FormHelperText>
                  )}
                  <Input
                    fullWidth
                    name="newPassword12313"
                    label="New Password"
                    type={showPassword ? "text" : "password"}
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      setError((prev) => ({ ...prev, password: "" }));
                    }}
                    autoComplete="new-password"
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            sx={{ mr: 1 }}
                          >
                            {showPassword ? (
                              <HtmlTooltip
                                title={"Hide New Password"}
                                arrow
                                placement="bottom"
                                sx={{ fontSize: 12 }}
                              >
                                <Visibility style={{ fontSize: 20 }} />
                              </HtmlTooltip>
                            ) : (
                              <HtmlTooltip
                                title={"Show New Password"}
                                arrow
                                placement="bottom"
                                sx={{ fontSize: 12 }}
                              >
                                <VisibilityOff style={{ fontSize: 20 }} />
                              </HtmlTooltip>
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {error.password && (
                    <FormHelperText sx={{ color: "#C52A1A", fontSize: "12px" }}>
                      {error.password}
                    </FormHelperText>
                  )}
                  <Input
                    fullWidth
                    name="confirmPassword"
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setError((prev) => ({ ...prev, confirmPassword: "" }));
                    }}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            sx={{ mr: 1 }}
                          >
                            {showConfirmPassword ? (
                              <HtmlTooltip
                                title={"Hide Confirm Password"}
                                arrow
                                placement="bottom"
                                sx={{ fontSize: 12 }}
                              >
                                <Visibility style={{ fontSize: 20 }} />
                              </HtmlTooltip>
                            ) : (
                              <HtmlTooltip
                                title={"Show Confirm Password"}
                                arrow
                                placement="bottom"
                                sx={{ fontSize: 12 }}
                              >
                                <VisibilityOff style={{ fontSize: 20 }} />
                              </HtmlTooltip>
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {error.confirmPassword && (
                    <FormHelperText sx={{ color: "#C52A1A", fontSize: "12px" }}>
                      {error.confirmPassword}
                    </FormHelperText>
                  )}
                </div>
                {firstLogin &&
                  <Typography variant="body2" gutterBottom>Click <Link
                    style={{
                      color: theme?.customSettings?.themeColor,
                      textDecorationColor: theme?.customSettings?.themeColor,
                      cursor: 'pointer'
                    }}
                    onClick={handleClose}
                  >here</Link> to accept the Terms of Use, Consent Notice & Privacy Policy</Typography>
                }

                <Button
                  type="submit"
                  className={styles.loginButton}
                  style={{
                    backgroundColor: theme?.customSettings?.themeColor,
                    color: "#FFF",
                  }}
                  disabled={resetPasswordMutation.isLoading}
                >
                  {resetPasswordMutation.isLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Change Password"
                  )}
                </Button>
              </>
            )}
          </form>
          <Divider />
        </div>
        <footer className={styles.footer}>
          <Grid2 container>
            <Grid2 size={{ xs: 12, md: 12, textAlign: "center" }}>
              <Typography
                variant="body2"
                textAlign={"center"}
                sx={{ fontSize: "14px", color: "#252525" }}
              >
                <span style={{ opacity: 0.5 }}>&copy; 2025 PwC. All rights reserved. PwC refers to india member firm and may sometimes refer to the PwC network. Each member firm is a separate legal entity. Please see </span><Link target="_blank" href="https://www.pwc.com/structure" sx={{
                  color: '#000', opacity: 1
                }}>www.pwc.com/structure</Link> <span style={{ opacity: 0.5 }}>for further details.</span>
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 2 }} />
            <Grid2 size={{ xs: 12, md: 12 }} textAlign={"center"} mt={1}>
              <Link
                target="_blank"
                href="/privacy-policy"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Privacy policy
              </Link>{" "}
              |{" "}
              {/* <Link
                href="#"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Cookie notice
              </Link>{" "} */}
              {/* |{" "} */}
              <Link
                target="_blank"
                href="/terms-conditions"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Terms and conditions
              </Link>{" "}
              |{" "}
              <Link
                href="/consent-notice"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Consent Notice
              </Link>
            </Grid2>
          </Grid2>
        </footer>
      </div>
      {!isMobile &&
        <div className={styles.leftPane}
          style={{
            backgroundImage: `url(${pwcImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          {/* <div className={styles.imageContainer}>
            <img src={pwcImage} alt="PwC Logo" />
          </div> */}
        </div>
      }
      <React.Fragment>
        <Dialog
          open={open}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              // prevent outside click or ESC close
              return;
            }
            handleClose();
          }}
          scroll={'paper'}
          maxWidth={'md'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          sx={{
            "& .MuiDialog-paper": {
              overflowY: "inherit",
            },
          }}
        >
          <DialogTitle id="scroll-dialog-title">Please Scroll Down To Accept Privacy Policy, Consent Notice and The Terms Of Use</DialogTitle>
          <DialogContent dividers={true}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
            >
              <PrivacyPolicy pValue={{ py: 1, px: 0 }} />
              <ConsentNotice pValue={{ py: 1, px: 0 }} />
              <TermsConditions pValue={{ py: 1, px: 0 }} />
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <FormGroup>
                  <FormControlLabel control={<Checkbox
                    checked={isChecked}
                    onChange={handleChange}
                    sx={{
                      color: `${theme?.customSettings?.themeColor}`,
                      '&.Mui-checked': {
                        color: `${theme?.customSettings?.themeColor}`,
                      },
                    }}
                  />} label="I Agree" />
                </FormGroup>
              </Box>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  borderColor: `${theme?.customSettings?.themeColor}`,
                  textTransform: 'none'
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button variant="contained"
                disabled={!isChecked}
                onClick={() => {
                  if (!isChecked) {
                    openNotification("Please Accept The Terms Of Use, Consent Notice & Privacy Policy");
                    return
                  }
                  handleClose();
                }}
                sx={{
                  backgroundColor: `${theme?.customSettings?.themeColor}`,
                  borderColor: `${theme?.customSettings?.themeColor}`,
                  textTransform: 'none'
                }}
              >
                Accept
              </Button>

            </Stack>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>

  );
};

export default ForgotPassword;
